// En qué idioma quiere jugar el jugador. Uno solo para las dos pantallas.
//
// T2b de `odd/tasks/el-idioma-del-jugador.md`.
//
// `pedir` ES EL `FETCH` CON CREDENCIAL, Y LLEGA POR PROP
// ------------------------------------------------------
// Mismo motivo que en `SportsbookC360`: este selector lo montan LAS DOS
// pantallas —la mini-app de Telegram y el sitio— y cada una se identifica
// distinto. Elegir acá adentro significaría o importar `cabeceraWeb`, que es
// privada de `Web.jsx`, o llamar a `fetchConSesion`, que manda el token de
// Telegram y en el sitio saldría sin credencial. Quien sabe cuál corresponde
// es quien monta.
//
// LO MARCADO SALE DEL RESOLVEDOR, NO DE `user.idioma`
// ----------------------------------------------------
// Y es la decisión que hace que la pantalla no mienta. Un jugador que nunca
// eligió tiene `user.idioma` nulo, pero NO está jugando en la nada: está
// jugando en el idioma de su navegador, porque es lo que `idiomaDelJugador`
// le manda al proveedor. Si el marcado saliera del campo crudo, el selector
// aparecería vacío y el jugador no tendría forma de saber en qué idioma está
// —ni se enteraría de que ya está en el que quiere—.
//
// EL ESTADO NO VIVE ACÁ
// ----------------------
// El componente no se guarda el idioma elegido: avisa con `onElegido` y
// vuelve a dibujar desde el `user` que le pasan. Si se lo guardara, un pedido
// que falla dejaría la pantalla marcando un idioma que la fila no tiene, que
// es la clase de desacuerdo que en este repo ya pagó caro: una pantalla que
// confirma lo que el servidor no hizo. Acá no es plata, pero el patrón es el
// mismo y la solución también: una sola fuente, y es la de afuera.

import { useState } from "react";
import { getFrontendConfig } from "./config";
import { oscuro as Q, F_BODY, RADII } from "./theme";
import Icon from "./Icon";
import { IDIOMAS, NOMBRES, idiomaDelJugador } from "./idioma";

const { apiUrl: API } = getFrontendConfig();

export default function SelectorDeIdioma({ user, pedir, onElegido }) {
  // El que el jugador está usando HOY: su elección si la hizo, y si no la del
  // navegador, que es la que de verdad viaja al proveedor.
  const actual = idiomaDelJugador(user);
  const [enVuelo, setEnVuelo] = useState(null);
  const [err, setErr] = useState("");

  const elegir = async (idioma) => {
    // Ya está en ese idioma, o hay un cambio en curso: nada que pedir.
    if (idioma === actual || enVuelo) return;
    setEnVuelo(idioma);
    setErr("");
    try {
      const r = await pedir(`${API}/api/jugador/idioma`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idioma }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "No se pudo cambiar el idioma");
      // El que contestó el servidor, no el que se tocó: el que vale es el que
      // quedó escrito en la fila.
      onElegido(d.idioma);
    } catch (e) {
      setErr(e.message);
    }
    setEnVuelo(null);
  };

  return (
    <div>
      {IDIOMAS.map((idioma) => {
        const puesto = idioma === actual;
        return (
          <button key={idioma} onClick={() => elegir(idioma)}
            aria-pressed={puesto} disabled={!!enVuelo}
            style={{ width: "100%",
              background: puesto ? `${Q.violet}33` : "transparent",
              border: `1px solid ${puesto ? Q.violet : Q.border}`,
              borderRadius: RADII.md, padding: "12px", marginBottom: 7,
              color: puesto ? Q.cyan : Q.text, fontSize: 13,
              fontWeight: puesto ? 700 : 400,
              cursor: enVuelo ? "default" : "pointer",
              display: "flex", justifyContent: "space-between",
              alignItems: "center", fontFamily: F_BODY }}>
            <span>{NOMBRES[idioma]}</span>
            {puesto && <Icon name="circle-check" size={14} />}
          </button>
        );
      })}

      {err && (
        <div role="alert" style={{ color: Q.red, fontSize: 12.5, marginTop: 4,
          lineHeight: 1.5, fontFamily: F_BODY }}>{err}</div>
      )}
    </div>
  );
}
